import { BrandedSpinner } from "./ui/branded-spinner";
import { CenteredCard } from "./ui/centered-card";

export function StoryLoadingState() {
    return (
        <CenteredCard>
            <div className="text-center space-y-6">
                <BrandedSpinner size="lg" animation="hybrid" speed="slow" />
                <div className="space-y-2">
                    <h2 className="text-2xl font-bold">Loading Story...</h2>
                    <p className="text-muted-foreground">Getting your story ready!</p>
                </div>
            </div>
        </CenteredCard>
    );
}
